import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.goToMenuPath && _ctx.goToMenuPath(...args)), ["prevent"])),
        innerHTML: _ctx.titleToUse
    }, null, 8, _hoisted_1));
}
